/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Duration } from './';
import {
    DurationFromJSON,
    DurationFromJSONTyped,
    DurationToJSON,
} from './';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';
import type { WorkConditions } from './';
import {
    WorkConditionsFromJSON,
    WorkConditionsFromJSONTyped,
    WorkConditionsToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkConditionsAndDurationField
 */
export interface WorkConditionsAndDurationField extends UpdatedField {
    /**
     * 
     * @type {WorkConditions}
     * @memberof WorkConditionsAndDurationField
     */
    workConditions: WorkConditions;
    /**
     * 
     * @type {Duration}
     * @memberof WorkConditionsAndDurationField
     */
    duration: Duration;
}

/**
 * Check if a given object implements the WorkConditionsAndDurationField interface.
 */
export function instanceOfWorkConditionsAndDurationField(value: object): value is WorkConditionsAndDurationField {
    if (!('workConditions' in value) || value['workConditions'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    return true;
}

export function WorkConditionsAndDurationFieldFromJSON(json: any): WorkConditionsAndDurationField {
    return WorkConditionsAndDurationFieldFromJSONTyped(json, false);
}

export function WorkConditionsAndDurationFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkConditionsAndDurationField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldFromJSONTyped(json, ignoreDiscriminator),
        'workConditions': WorkConditionsFromJSON(json['workConditions']),
        'duration': DurationFromJSON(json['duration']),
    };
}

export function WorkConditionsAndDurationFieldToJSON(value?: WorkConditionsAndDurationField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldToJSON(value, true),
        'workConditions': WorkConditionsToJSON(value['workConditions']),
        'duration': DurationToJSON(value['duration']),
    };
}

